module.exports = __webpack_public_path__ + "img/hr-dead-grey-trunk-03.e4cfa841.png";